export default __webpack_public_path__ + "static/media/hht2_Intonation_11.a54e68c9.png";